<template>
  <b-modal 
    ref="modalManutencao" 
    id="modal-manutencao" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="lg"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
         style="background: linear-gradient(135deg, #f86c6b 0%, #e55353 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-wrench text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">{{ manutencao.ID ? 'Editar' : 'Nova' }} Manutenção</h5>
        <small class="text-white opacity-75">Registro de manutenção/reparo do veículo</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <!-- Alerta de Título Gerado -->
    <b-alert v-if="tituloGerado" show variant="danger" class="m-3 mb-0">
      <i class="fa fa-exclamation-triangle mr-2"></i>
      Essa movimentação gerou um título no Contas a Pagar com número: <strong>MNT{{ manutencao.ID }}/1</strong>
    </b-alert>

    <!-- Corpo do Modal -->
    <div class="p-4">
      <div class="modal-section-title mb-3">
        <i class="fa fa-clipboard mr-2 text-danger"></i> Dados da Movimentação
      </div>

      <b-row>
        <b-col md="4">
          <label class="modal-label-premium">Nota Fiscal</label>
          <b-form-input 
            v-model="manutencao.NOTA_FISCAL" 
            ref="notaFiscal"
            maxlength="20"
            class="rounded-pill shadow-xs"
          ></b-form-input>
        </b-col>

        <b-col md="4">
          <label class="modal-label-premium">Data da Manutenção *</label>
          <cec-input-data
            v-model="manutencao.DATA" 
            :state="manutencao.DATA ? null : false"
            input-class="rounded-pill shadow-xs"
          />
        </b-col>

        <b-col md="4">
          <label class="modal-label-premium">Quilometragem *</label>
          <vue-autonumeric
            v-model="manutencao.ULTIMA_KM"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }"
            :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid': !(manutencao.ULTIMA_KM > 0), 'is-valid': manutencao.ULTIMA_KM > 0 }]"
          />
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-dollar mr-2 text-danger"></i> Valores do Serviço
      </div>

      <b-row>
        <b-col md="12">
          <label class="modal-label-premium">Valor do Serviço *</label>
          <vue-autonumeric
            v-model="manutencao.TOTAL"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2, currencySymbol: 'R$ ', currencySymbolPlacement: 'p' }"
            :class="['form-control rounded-pill shadow-xs text-right font-weight-bold text-danger', { 'is-invalid': !(manutencao.TOTAL > 0), 'is-valid': manutencao.TOTAL > 0 }]"
          />
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-users mr-2 text-danger"></i> Executor e Responsáveis
      </div>

      <b-row>
        <b-col md="6">
          <label class="modal-label-premium">Executor do Serviço *</label>
          <cliente-pesquisa 
            @retornaId="manutencao.EXECUTOR_SERVICO_ID = $event" 
            :idInicial="manutencao.EXECUTOR_SERVICO_ID" 
            label="" 
            place="Pesquise o executor (oficina/mecânico)"
            :state="manutencao.EXECUTOR_SERVICO_ID ? null : false"
            :arredondado="true"
          ></cliente-pesquisa>
        </b-col>

        <b-col md="6">
          <label class="modal-label-premium">Responsável *</label>
          <funcionario-dropdown 
            v-model="manutencao.RESPONSAVEL_ID"
            :state="manutencao.RESPONSAVEL_ID ? null : false"
            input-class="rounded-pill shadow-xs"
          ></funcionario-dropdown>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="12">
          <label class="modal-label-premium">Histórico *</label>
          <historico-caixa-dropdown 
            v-model="manutencao.HISTORICO_ID"
            tipo="DEBITO"
            :state="manutencao.HISTORICO_ID ? null : false"
            input-class="rounded-pill shadow-xs"
          ></historico-caixa-dropdown>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-file-text-o mr-2 text-danger"></i> Detalhes Financeiros
      </div>

      <b-row>
        <b-col md="6">
          <label class="modal-label-premium">Data de Vencimento</label>
          <cec-input-data
            v-model="manutencao.DATA_VENCIMENTO" 
            input-class="rounded-pill shadow-xs"
          />
        </b-col>

        <b-col md="6">
          <label class="modal-label-premium">Centro de Custo</label>
          <centro-custo-drop-down 
            v-model="manutencao.CENTRO_CUSTO_ID"
            input-class="rounded-pill shadow-xs"
          ></centro-custo-drop-down>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="12">
          <label class="modal-label-premium">Observações (Max. 200 caracteres)</label>
          <b-form-textarea 
            v-model="manutencao.OBSERVACOES" 
            rows="3"
            maxlength="200"
            class="rounded shadow-xs"
          ></b-form-textarea>
        </b-col>
      </b-row>
    </div>

    <!-- Rodapé de Ações -->
    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar">
        CANCELAR
      </b-button>
      <b-button variant="danger" pill class="px-5 font-weight-bold shadow-sm" @click="salvar">
        <i class="fa fa-check-circle mr-1"></i> {{ manutencao.ID ? 'ATUALIZAR' : 'SALVAR' }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'
import ClientePesquisa from '../../../pesquisa/ClientePesquisa'
import FuncionarioDropdown from '../../../componentes/dropdown/FuncionarioDropdown.vue'
import HistoricoCaixaDropdown from '../../../componentes/dropdown/HistoricoCaixaDropdown.vue'
import CentroCustoDropDown from '../../../componentes/dropdown/CentroCustoDropDown.vue'
import CecInputData from '../../../../components/Cec/CecInputData.vue'
import Tools from '../../../../tools/Tools'

export default {
  name: 'ManutencaoModal',
  components: {
    VueAutonumeric,
    ClientePesquisa,
    FuncionarioDropdown,
    HistoricoCaixaDropdown,
    CentroCustoDropDown,
    CecInputData
  },
  props: {
    veiculoId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      manutencao: this.getNovaManutencao()
    }
  },
  computed: {
    tituloGerado () {
      return this.manutencao.OP_GERA_TITULO === '1' && this.manutencao.APAGAR_ID > 0
    }
  },
  methods: {
    getNovaManutencao () {
      return {
        ID: null,
        VEICULO_ID: this.veiculoId,
        NOTA_FISCAL: '0',
        DATA: new Date().toISOString().split('T')[0],
        ULTIMA_KM: 0,
        TOTAL: 0,
        EXECUTOR_SERVICO_ID: null,
        RESPONSAVEL_ID: null,
        HISTORICO_ID: null,
        DATA_VENCIMENTO: null,
        CENTRO_CUSTO_ID: null,
        OBSERVACOES: '',
        OP_GERA_TITULO: '0',
        APAGAR_ID: null
      }
    },

    async abrir (manutencaoId = null) {
      if (manutencaoId) {
        await this.carregar(manutencaoId)
      } else {
        this.manutencao = this.getNovaManutencao()
      }
      
      this.$refs.modalManutencao.show()
    },

    async carregar (id) {
      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.$http.get(`/api/protected/veiculo/manutencao/${id}`)
        if (result.data) {
          this.manutencao = { ...result.data }
        }
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao carregar manutenção')
        console.error(error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async salvar () {
      if (!this.validar()) return

      this.$store.commit('controle/setAguardando', true)
      try {
        const url = this.manutencao.ID 
          ? '/api/protected/veiculo/manutencao/edit'
          : '/api/protected/veiculo/manutencao/post'
        
        // Converter EXECUTOR_SERVICO_ID para FORNECEDOR_ID (campo esperado pelo backend)
        const registroParaEnviar = {
          ...this.manutencao,
          FORNECEDOR_ID: this.manutencao.EXECUTOR_SERVICO_ID
        }
        delete registroParaEnviar.EXECUTOR_SERVICO_ID
        
        const result = await this.$http.post(url, { registro: registroParaEnviar })
        
        if (result.data.result === 'sucesso') {
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', this.manutencao.ID ? 'Manutenção atualizada com sucesso!' : 'Manutenção cadastrada com sucesso!')
          this.$emit('salvou')
          this.fechar()
        } else {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', result.data.mensagem || 'Erro ao salvar manutenção')
        }
      } catch (error) {
        const mensagemErro = error.response?.data || error.message || 'Erro ao salvar manutenção'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', mensagemErro)
        console.error(error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    validar () {
      if (!this.manutencao.DATA) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe a data da manutenção')
        return false
      }
      if (!this.manutencao.ULTIMA_KM || this.manutencao.ULTIMA_KM <= 0) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe a quilometragem')
        return false
      }
      if (!this.manutencao.TOTAL || this.manutencao.TOTAL <= 0) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o valor do serviço')
        return false
      }
      if (!this.manutencao.EXECUTOR_SERVICO_ID) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione o executor do serviço')
        return false
      }
      if (!this.manutencao.RESPONSAVEL_ID) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione o responsável')
        return false
      }
      if (!this.manutencao.HISTORICO_ID) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione o histórico de lançamento')
        return false
      }
      return true
    },

    fechar () {
      this.$refs.modalManutencao.hide()
    },

    onModalShown () {
      this.$nextTick(() => {
        if (this.$refs.notaFiscal) {
          this.$refs.notaFiscal.focus()
        }
      })
    },

    onModalHidden () {
      this.manutencao = this.getNovaManutencao()
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.modal-footer-premium {
  border-top: 1px solid #e9ecef;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/veiculo/components/ManutencaoModal.vue